import React, { useState } from 'react';
import { User, Mail, Lock, Phone, MapPin, Building, Briefcase, ArrowLeft, Eye, EyeOff } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebaseConfig';
import { setDoc, doc, serverTimestamp } from 'firebase/firestore';
import './Register.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const Kayit = () => {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  
  const [activeTab, setActiveTab] = useState('oyuncu'); // 'oyuncu' | 'tesis'
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // --- FORM VERİLERİ ---
  const [formData, setFormData] = useState({
    ad: '', soyad: '', il: '', ilce: '',
    isletmeAdi: '', vergiNo: '', telefon: '',
    email: '', username: '', password: '', passwordConfirm: '',
    position: 'Forvet',
    // Checkbox Alanları
    hasShower: false, hasParking: false,
    rentCleats: false, rentGloves: false, rentShorts: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // --- GOOGLE İLE KAYIT/GİRİŞ ---
  const handleGoogleAuth = async () => {
    try {
      await loginWithGoogle();
      alert("✅ Google ile Giriş Başarılı!");
      navigate('/profile');
    } catch (error) {
      console.error("Google Auth Error:", error);
      alert("Google ile giriş/kayıt başarısız oldu: " + (error.message || error));
    }
  };

  // --- KAYIT GÖNDERME İŞLEMİ ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.passwordConfirm) {
      alert("❌ Şifreler eşleşmiyor!");
      return;
    }

    try {
      if (activeTab === 'oyuncu') {
        // --- OYUNCU KAYDI ---
        const response = await axios.post(`${API_URL}/api/auth/register`, {
          username: formData.username,
          email: formData.email,
          password: formData.password,
          ad: formData.ad,
          soyad: formData.soyad,
          il: formData.il,
          ilce: formData.ilce,
          position: formData.position,
          role: "user"
        });

        if (response.status === 201 || response.status === 200) {
          const createdUser = response.data;
          const userId = createdUser._id;

          // Firestore'da profil oluştur
          await setDoc(doc(db, "userProfiles", userId), {
            name: formData.ad,
            surname: formData.soyad,
            city: formData.il,
            district: formData.ilce,
            position: formData.position,
            username: formData.username.toLowerCase(),
            email: formData.email.toLowerCase(),
            photoURL: "",
            matchesPlayed: 0,
            goalsThisWeek: 0,
            playedFields: [],
            followers: [],
            following: []
          });

          alert("✅ Oyuncu Kaydı Başarılı! Giriş ekranına yönlendiriliyorsunuz.");
          navigate('/giris');
        }
      } else {
        // --- HALI SAHA (TESİS) KAYDI ---
        const response = await axios.post(`${API_URL}/api/auth/register`, {
          username: formData.username,
          email: formData.email,
          password: formData.password,
          ad: formData.ad,
          soyad: formData.soyad,
          il: formData.il,
          ilce: formData.ilce,
          role: "admin"
        });

        if (response.status === 201 || response.status === 200) {
          const createdUser = response.data;
          const userId = createdUser._id;

          // Firestore'da tesis oluştur (pending durumunda onay bekler)
          await setDoc(doc(db, "tesisler", userId), {
            fieldName: formData.isletmeAdi,
            email: formData.email.toLowerCase(),
            name: formData.ad,
            surname: formData.soyad,
            phone: formData.telefon,
            city: formData.il,
            district: formData.ilce,
            status: "pending",
            username: formData.username.toLowerCase(),
            password: formData.password,
            createdAt: serverTimestamp(),
            hasShower: formData.hasShower,
            hasParking: formData.hasParking,
            rentCleats: formData.rentCleats,
            rentGloves: formData.rentGloves,
            rentShorts: formData.rentShorts
          });

          alert("✅ Başvuru Alındı! Halı sahanız Süper Admin onayına gönderilmiştir.");
          navigate('/giris');
        }
      }
    } catch (error) {
      console.error("Kayıt Hatası:", error);
      const errMsg = error.response?.data?.error || error.response?.data?.message || error.message;
      alert(`❌ Kayıt başarısız! Hata: ${errMsg}`);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box" style={{ maxWidth: '580px' }}>
        
        <Link to="/giris" className="back-button-top">
          <ArrowLeft size={20} /> Giriş Yap
        </Link>

        <div className="header-section text-center mb-4">
          <h2>SahaLive Kayıt</h2>
          <p>SahaLive ailesine katılarak oynamaya veya yönetmeye başlayın!</p>
        </div>

        {/* TABS (Oyuncu / Halı Saha Seçimi) */}
        <div className="d-flex justify-content-center mb-4 border-bottom pb-2">
          <button 
            type="button" 
            className={`btn rounded-pill px-4 me-2 fw-bold ${activeTab === 'oyuncu' ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => setActiveTab('oyuncu')}
          >
            ⚽ Oyuncu Kaydı
          </button>
          <button 
            type="button" 
            className={`btn rounded-pill px-4 fw-bold ${activeTab === 'tesis' ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => setActiveTab('tesis')}
          >
            🏟️ Halı Saha Kaydı
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          
          {/* KİŞİSEL BİLGİLER */}
          <div className="form-row">
            <div className="input-group">
              <User size={18} />
              <input type="text" name="ad" placeholder="Adınız" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <User size={18} />
              <input type="text" name="soyad" placeholder="Soyadınız" onChange={handleChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="input-group">
              <MapPin size={18} />
              <input type="text" name="il" placeholder="Şehir / İl" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <MapPin size={18} />
              <input type="text" name="ilce" placeholder="İlçe" onChange={handleChange} required />
            </div>
          </div>

          {/* OYUNCU MEVKİİ SEÇİMİ */}
          {activeTab === 'oyuncu' && (
            <div className="input-group full-width mb-3">
              <span className="me-2 fw-bold text-secondary" style={{ fontSize: '14px' }}>Mevki:</span>
              <select name="position" onChange={handleChange} className="form-select border-0 bg-transparent text-secondary p-0" style={{ boxShadow: 'none' }}>
                <option value="Forvet">Forvet</option>
                <option value="Orta Saha">Orta Saha</option>
                <option value="Defans">Defans</option>
                <option value="Kaleci">Kaleci</option>
              </select>
            </div>
          )}

          {/* İŞLETME BİLGİLERİ (Sadece Tesis sekmesinde) */}
          {activeTab === 'tesis' && (
            <>
              <div className="input-group full-width">
                <Building size={18} />
                <input type="text" name="isletmeAdi" placeholder="Halı Saha İsmi" onChange={handleChange} required />
              </div>
              <div className="input-group full-width">
                <Briefcase size={18} />
                <input type="text" name="vergiNo" placeholder="Vergi No / TC No" onChange={handleChange} required />
              </div>
              <div className="input-group full-width">
                <Phone size={18} />
                <input type="tel" name="telefon" placeholder="İletişim Telefonu (05XX...)" onChange={handleChange} required />
              </div>
            </>
          )}

          {/* HESAP BİLGİLERİ */}
          <div className="form-row">
            <div className="input-group">
              <Mail size={18} />
              <input type="email" name="email" placeholder="E-posta" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <User size={18} />
              <input type="text" name="username" placeholder="Kullanıcı Adı" onChange={handleChange} required />
            </div>
          </div>
          
          <div className="form-row">
            <div className="input-group" style={{ position: 'relative' }}>
              <Lock size={18} />
              <input 
                type={showPassword ? "text" : "password"} 
                name="password" 
                placeholder="Şifre" 
                onChange={handleChange} 
                required 
                style={{ paddingRight: '45px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  color: '#a0aec0',
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            <div className="input-group" style={{ position: 'relative' }}>
              <Lock size={18} />
              <input 
                type={showConfirmPassword ? "text" : "password"} 
                name="passwordConfirm" 
                placeholder="Şifre Tekrar" 
                onChange={handleChange} 
                required 
                style={{ paddingRight: '45px' }}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  right: '15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  color: '#a0aec0',
                  zIndex: 10,
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {/* TESİS ÖZELLİKLERİ (Sadece Tesis sekmesinde) */}
          {activeTab === 'tesis' && (
            <div style={styles.featuresContainer}>
              <p style={styles.featuresTitle}>Tesis Özellikleri & İmkanlar</p>
              <div style={styles.checkboxGroup}>
                <label style={styles.checkboxLabel}><input type="checkbox" name="hasShower" onChange={handleChange} /> Duş</label>
                <label style={styles.checkboxLabel}><input type="checkbox" name="hasParking" onChange={handleChange} /> Otopark</label>
                <label style={styles.checkboxLabel}><input type="checkbox" name="rentCleats" onChange={handleChange} /> Krampon</label>
                <label style={styles.checkboxLabel}><input type="checkbox" name="rentGloves" onChange={handleChange} /> Eldiven</label>
                <label style={styles.checkboxLabel}><input type="checkbox" name="rentShorts" onChange={handleChange} /> Şort</label>
              </div>
            </div>
          )}

          <button type="submit" className="submit-btn mt-3">Kaydol</button>
        </form>

        {/* GOOGLE İLE KAYDOL (Giriş sayfasından sadece buraya taşındı) */}
        <div className="divider text-center my-3 text-muted">
          <span>veya</span>
        </div>

        <button 
          type="button" 
          onClick={handleGoogleAuth} 
          className="btn btn-outline-dark rounded-pill w-100 fw-bold py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm"
        >
          <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" style={{ width: '18px' }} />
          Google ile Hızlı Giriş Yap / Kaydol
        </button>

        <div className="footer-link text-center mt-4">
          <p>Zaten hesabınız var mı? <Link to="/giris" className="fw-bold text-primary text-decoration-none">Giriş Yapın</Link></p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  featuresContainer: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    marginTop: '15px',
    marginBottom: '15px',
    border: '1px solid #e9ecef'
  },
  featuresTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#495057',
    marginBottom: '10px'
  },
  checkboxGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '15px'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '13px',
    color: '#343a40',
    cursor: 'pointer',
    userSelect: 'none'
  }
};

export default Kayit;